/**
 * shouldCache
 * @description Checks the current env and query to see if we should cache.
 * Safeguards against users that are impersonating other users as well as mutation or
 * subscription GQL requests
 * @param {*} query - The API query to check
 * @param {*} windowObj - globalThis to check for keys
 * @returns Boolean
 */
export const shouldCache = (query, windowObj) => {
	if (!query || !windowObj) return false;

	if (windowObj.NOW?.user?.isImpersonating === true) return false;

	if (query.definitions) {
		if (
			query.definitions.every(d => d.operation === 'mutation') ||
			query.definitions.every(d => d.operation === 'subscription')
		)
			return false;
	}

	return true;
};
